import { clientConnector } from '@games/socket-client'

/**
 * Расширяет clientConnector для работы с быстрым чатом
 */
export function extendSocketWithChat(): void {
  // Регистрируем компонент для игровых событий
  const chatComponent = {
    name: 'chat',
    methods: {
      // Чат и реакции
      sendChat: {
        emitEvent: 'game:sendChat',
        expectsResponse: true,
        timeout: 2000,
        responseMethodName: 'onChatSent'
      },
      onChatReceived: {
        listenEvent: 'game:onChatReceived',
        responseMethodName: 'onChatReceived'
      }
    }
  }
  // Регистрируем компонент
  clientConnector.registerComponent(chatComponent);
}
